import { AlertType } from '../../enums/AlertType';
import { Alert } from '../../interfaces/Alert';
export const ALERT_MARKETPLACE_BID_REMOVE_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.bid_removed',
    translate: true,
  },
};
